import * as React from "react";
import { useGetAllReasonsQuery } from "../services/reason.service";
import SelectBase, { SelectOption } from "./global/SelectBase";

const SelectReason = ({
  onChange,
  sx,
  value,
  error,
  helperText,
}: {
  onChange: (arg?: number) => void;
  sx?: any;
  value: number;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const {
    data: reasons,
    isLoading,
  } = useGetAllReasonsQuery({
    sortField: "name",
    sortMode: "asc",
  });

  const options = React.useMemo<SelectOption[]>(() => {
    return (reasons || []).map((reason) => ({
      label: reason.name,
      value: reason.id,
    }));
  }, [reasons]);

  const selected = React.useMemo<SelectOption | null>(() => {
    if (!value || !reasons) return null;
    const reason = reasons.find((it) => it.id === value);
    return reason ? { label: reason.name, value: reason.id } : null;
  }, [reasons, value]);

  return (
    <SelectBase
      options={options}
      value={selected}
      onChange={(newValue) => {
        const option = newValue as SelectOption | null;
        onChange(option?.value as number | undefined);
      }}
      label="Reason"
      placeholder="Search..."
      isLoading={isLoading}
      error={error}
      helperText={helperText}
      sx={sx}
    />
  );
};
export default SelectReason;
